import { render, staticRenderFns } from "./RoofCalNoti.vue?vue&type=template&id=5ec9bcbc&scoped=true"
import script from "./RoofCalNoti.vue?vue&type=script&lang=js"
export * from "./RoofCalNoti.vue?vue&type=script&lang=js"
import style0 from "./RoofCalNoti.vue?vue&type=style&index=0&id=5ec9bcbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec9bcbc",
  null
  
)

export default component.exports